module.exports = __webpack_public_path__ + "static/img/Viewmed-ClaveProfesional.eea2975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Viewmed-ClaveProfesional.png
// module id = PLTv
// module chunks = 0